<template>
    <div class="m-portlet m-portlet--head-sm" v-loading="loading" v-if="powers.includes(53)">
        <div>
            <div>
                <h3 style="margin-left: 20px">{{filter.date}}</h3>
                <div style="margin-top: -33px;text-align: center;">
                    <el-button-group>
                        <el-button type="success" icon="el-icon-arrow-left" @click="handleLastWeek" style="height: 33px"></el-button>
                        <el-button type="success" @click="handleToday" style="height: 33px">今天</el-button>
                        <el-button type="success" @click="handleNextWeek" style="height: 33px"><i class="el-icon-arrow-right el-icon--right"></i></el-button>
                    </el-button-group>
                </div>
            </div>
        </div>
        <div class="m-portlet__body"  v-if="V4Judge">
            <TeacherTable ref="V4Table" v-show="V4Show"> </TeacherTable>
        </div>
    </div>
</template>
<script>
    import index from './Index';
    export default {
        name: "OperationTeacher",
        data() {
            return {
                path:"/timeTable/teacher",
                loading:true,
                V4Judge:false,
                V4Show:false,
                showStudent:false,
                weeks:[],
                basisTime:[],
                classes:[],
                class_student:{},
                scroll: {
                    left: 0,
                    top: 0
                },
                filter:{
                    grade_id:[],
                    date:this.$moment().format('YYYY-MM-DD')
                },
                startTime:8,
            }
        },
        components: {
            'TeacherTable': index,
        },
        created() {
            this.$wApi.addListen(this.path,this.handleData);
            this.handleShow()
        },
        beforeDestroy(){
            this.$wApi.removeListen(this.path)
        },
        computed: {
            powers(){
                return this.$store.state.config.powers;
            }
        },
        methods: {
            handleData(event, data) {
                switch (event) {
                    case 'subscribe':
                        break;
                    case 'show':
                        this.classes = data.classes;
                        this.class_student = data.class_student;
                        this.weeks = data.weeks;
                        this.basisTime= data.basisTime;
                        this.V4Show=true;
                        this.loading = false;
                        this.V4Judge=true;
                        setTimeout(()=>{
                            if(this.V4Judge){
                                this.$refs.V4Table.initCanvas()
                            }
                        },100)
                        break;
                }
            },
            handleShow(){
                this.loading = true;
                this.$wApi.send(this.path,'show',{'date':this.filter.date});
                this.V4Show = false;
            },
            handleLastWeek(){
                this.filter.date=this.$moment(this.filter.date).subtract(7, 'days').format('YYYY-MM-DD')
                this.handleShow();
            },
            handleToday(){
                this.filter.date=this.$moment().format('YYYY-MM-DD');
                this.handleShow();
            },
            handleNextWeek(){
                this.filter.date=this.$moment(this.filter.date).add(7, 'days').format('YYYY-MM-DD')
                this.handleShow();
            },
        }
    }
</script>

<style scoped>

</style>